<template>
    <div class="body">
        <edit></edit>
    </div>
</template>
  
<script>
import edit from "@/components/moduleComponents/edit.vue";

export default {
name: "addUser",
    components: {
        edit,
    },
};
</script>
  